import { useContext, useCallback, useState, useMemo, useEffect } from "react"
import MaskDressform from "../components/MaskDressform/MaskDressform"
import MaskModel from "../components/MaskModelWithBgMoveable"
// import MaskModel from "../components/MaskModel/MaskModel"
import UploadShoes from "../components/UploadShoes"
import { IMAGE_TYPE } from '@utils/CONST'
import { GenerateContext } from "@utils/GenerateContext"
import { Upload, Spin } from "antd"
import styles from "./index.module.scss"
import Utils from "@utils/utils"
import useResizeObserver from "@utils/useResizeObserver"
import exampleJSON from '@assets/shoes_example/example.json'
import { LoadingOutlined } from '@ant-design/icons';

const SubCompShoes = (props) => {
    const {
        imgRatio,
        inputImage,
        maskMoveable,
        rightProjectId,
        setGlobaluploadLoading,
        segmentResult, setSegmentResult,
        segmentShoesResult1, setSegmentShoesResult1,
        segmentShoesResult2, setSegmentShoesResult2,
        aiInteractiveNpy, setAiInteractiveNpy,
        aiInteractiveShoesNpy1, setAiInteractiveShoesNpy1,
        aiInteractiveShoesNpy2, setAiInteractiveShoesNpy2,
    } = useContext(GenerateContext)

    const [upLoading, setLoading] = useState(false)
    const [upLoading1, setLoading1] = useState(false)
    const [upLoading2, setLoading2] = useState(false)

    const uploadDebounce = useCallback(_.debounce(async (file, fileList, shoesIndex) => {
        console.log('===uploadDebounce===')
        setGlobaluploadLoading(true)
        await props.reUpload(file, shoesIndex)
    }, 100), [])

    const handleDrop = async (e, shoesIndex) => {
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            if (filesAndDirs.length == 0) return false
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            uploadDebounce(fileList[0], fileList, shoesIndex)
            return false
        }
    }

    const [wrapWidth, setWrapWidth] = useState(0)
    const [wrapHeight, setWrapHeight] = useState(0)
    const targetRef = useResizeObserver((entries) => {
        for (let entry of entries) {
            // 处理尺寸变化的逻辑
            setWrapWidth(entry.contentRect.width)
            setWrapHeight(entry.contentRect.height)
        }
    })

    const sampleVisible = useMemo(() => {
        if (rightProjectId) return false
        if (wrapWidth < 680) {
            return false
        } else return true
    }, [wrapWidth, rightProjectId])

    const ExampleContent = (props) => {
        const data = exampleJSON.SHOES

        return (
            <div className={`${styles.ExampleContent} ${styles[props.direction]}`}>
                <div style={{ backgroundColor: '#fff' }}>
                    <img src={require(`@assets/shoes_example/${data[`correct_img`]}`)} />
                </div>
            </div>
        )
    }

    const haveShoes = useMemo(() => {
        return props.segmentResult.length > 0 || props.segmentShoesResult1.length > 0 || props.segmentShoesResult2.length > 0
    })

    const beforeUploadSingle = async (file, val) => {
        if (val === 1) { setLoading1(true) } else if (val === 2) { setLoading2(true) } else { setLoading(true) }
        await props.onBeforeUpload(file, false, null, val);
        setLoading(false); setLoading1(false); setLoading2(false)
        return false
    }

    // 拖拽相关状态
    const [dragFromIndex, setDragFromIndex] = useState(null)
    const handleDragStart = (fromIndex) => {
        setDragFromIndex(fromIndex)
    }
    const handleDropTo = (toIndex) => {
        if (dragFromIndex !== null && dragFromIndex !== toIndex) {
            console.log(`拖动: ${dragFromIndex} -> ${toIndex}`)
            swapViews(dragFromIndex, toIndex)
        }
        setDragFromIndex(null)
    }
    const swapViews = (from, to) => {
        if (from === to) return;

        // 定义数组映射
        const segmentSetters = [
            { get: segmentResult, set: setSegmentResult },
            { get: segmentShoesResult1, set: setSegmentShoesResult1 },
            { get: segmentShoesResult2, set: setSegmentShoesResult2 }
        ];

        const aiSetters = [
            { get: aiInteractiveNpy, set: setAiInteractiveNpy },
            { get: aiInteractiveShoesNpy1, set: setAiInteractiveShoesNpy1 },
            { get: aiInteractiveShoesNpy2, set: setAiInteractiveShoesNpy2 }
        ];

        // 对调 segment
        const tempSegment = segmentSetters[from].get;
        segmentSetters[from].set(segmentSetters[to].get);
        segmentSetters[to].set(tempSegment);

        // 对调 aiInteractive
        const tempAi = aiSetters[from].get;
        aiSetters[from].set(aiSetters[to].get);
        aiSetters[to].set(tempAi);
    };



    return (
        <>
            <div className={styles.Content} ref={targetRef}>
                <div className={styles.ContentUpload}>
                    {
                        haveShoes ?
                            // <Upload.Dragger
                            //     accept={'image/jpeg,image/png,image/webp,image/avif'}
                            //     name="avatar"
                            //     showUploadList={false}
                            //     className={styles.UploadWrap}
                            //     maxCount={1}
                            //     beforeUpload={() => false}
                            //     onDrop={(e) => handleDrop(e, 0)}
                            // >
                            <div className={styles.SubCompShoesBox} onClick={e => e.stopPropagation()}>
                                <div className={styles.shoesViewLeft} draggable
                                    onDragStart={() => handleDragStart(0)}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={() => handleDropTo(0)}>
                                    <span className={styles.maskBtnStyl} onClick={props.mattingOpt}>抠图优化</span>
                                    <span className={styles.viewStyl}>主视角</span>
                                    {
                                        props.segmentResult?.length > 0 ? <MaskDressform
                                            border
                                            shoesIndex={0}
                                            key={props.segmentResult[0]}
                                            imageType={IMAGE_TYPE.SHOES}
                                            aiInteractiveNpy={props.aiInteractiveNpy}
                                            segmentResult={props.segmentResult}
                                            reUpload={props.reUpload}
                                            deleteOpt={props.deleteOpt}
                                            mattingOpt={props.mattingOpt}
                                            onNpyChange={props.onNpyChange}
                                        /> : <Upload.Dragger
                                            accept={'image/jpeg,image/png,image/webp,image/avif'}
                                            name="avatar"
                                            showUploadList={false}
                                            className={styles.UploadWrap}
                                            maxCount={1}
                                            beforeUpload={(file) => beforeUploadSingle(file, 0)}
                                        >
                                            {
                                                upLoading ? <Spin size="large" /> : <img src={require('@assets/images/uploadAdd2.png')} />

                                            }
                                        </Upload.Dragger>
                                    }
                                </div>
                                <div className={styles.shoesViewRight}>
                                    <div className={styles.shoesViewRTop} draggable
                                        onDragStart={() => handleDragStart(1)}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={() => handleDropTo(1)}>
                                        <span className={styles.viewStyl}>辅助视角1</span>
                                        {
                                            props.segmentShoesResult1?.length > 0 ? <MaskDressform
                                                border
                                                shoesIndex={1}
                                                key={props.segmentShoesResult1[0]}
                                                imageType={IMAGE_TYPE.SHOES}
                                                aiInteractiveNpy={props.aiInteractiveShoesNpy1}
                                                segmentResult={props.segmentShoesResult1}
                                                reUpload={props.reUpload}
                                                deleteOpt={props.deleteOpt}
                                                mattingOpt={props.mattingOpt}
                                                onNpyChange={props.onNpyChange}
                                            /> : <Upload.Dragger
                                                accept={'image/jpeg,image/png,image/webp,image/avif'}
                                                name="avatar"
                                                showUploadList={false}
                                                className={styles.UploadWrap}
                                                maxCount={1}
                                                beforeUpload={(file) => beforeUploadSingle(file, 1)}
                                            >
                                                {
                                                    upLoading1 ? <Spin size="large" /> : <img src={require('@assets/images/uploadAdd2.png')} />

                                                }
                                            </Upload.Dragger>
                                        }

                                    </div>
                                    <div className={styles.shoesViewRBottom} draggable
                                        onDragStart={() => handleDragStart(2)}
                                        onDragOver={(e) => e.preventDefault()}
                                        onDrop={() => handleDropTo(2)}>
                                        <span className={styles.viewStyl}>辅助视角2</span>
                                        {
                                            props.segmentShoesResult2?.length > 0 ? <MaskDressform
                                                border
                                                shoesIndex={2}
                                                key={props.segmentShoesResult2[0]}
                                                imageType={IMAGE_TYPE.SHOES}
                                                aiInteractiveNpy={props.aiInteractiveShoesNpy2}
                                                segmentResult={props.segmentShoesResult2}
                                                reUpload={props.reUpload}
                                                deleteOpt={props.deleteOpt}
                                                mattingOpt={props.mattingOpt}
                                                onNpyChange={props.onNpyChange}
                                            /> : <Upload.Dragger
                                                accept={'image/jpeg,image/png,image/webp,image/avif'}
                                                name="avatar"
                                                showUploadList={false}
                                                className={styles.UploadWrap}
                                                maxCount={1}
                                                beforeUpload={(file) => beforeUploadSingle(file, 2)}
                                            >
                                                {
                                                    upLoading2 ? <Spin size="large" /> : <img src={require('@assets/images/uploadAdd2.png')} />

                                                }
                                            </Upload.Dragger>
                                        }
                                    </div>

                                </div>
                            </div>

                            // </Upload.Dragger>
                            :
                            <UploadShoes
                                imageType={props.imageType}
                                onBeforeUpload={props.onBeforeUpload}
                            />
                    }
                </div>
                {
                    !haveShoes && <div className={`${styles.ContentSample} ${!sampleVisible && styles.hidden}`}>
                        <ExampleContent direction="vertical" />
                    </div>
                }
            </div>
        </>



    )
}

export default SubCompShoes